import React, { useState } from "react";
import { Button, Col, Image, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { useNavigate } from "react-router-dom";

import email from "../../../../assets/email.png";
import { EmailCheck } from "../../../../ConditionChecks/ConditionChecks";
import { toast } from "react-toastify";
import { getForgotPswdCounter } from "../../../../Redux/ForgotpswdCounterSlice";
import ErrorLabel from "../../../../ErrorLabel/ErrorLabel";

import { userId } from "../../../../Utils/LocalStorage";
import SideBar from "../../../SideBar/SideBar";
import { newEmailApi } from "../../../API/new-email";
import { useDispatch } from "react-redux";
import BackButton from "../../../BackButton/BackButton";

const EditEmailAddress = ({}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [emailAddress, setEmailAddress] = useState("");
  const [errdisplay, setErrdisplay] = useState("");

  const handleEmailChange = (event) => {
    setEmailAddress(event.target.value);
    localStorage.setItem("newEmail", event.target.value);
  };

  const VerificationHandler = (event) => {
    event.preventDefault();

    const emailCheck = EmailCheck(emailAddress);
    if (emailCheck.input === "empty") {
      setErrdisplay(emailCheck.err_display);
    } else if (emailCheck.input === "invalid") {
      setErrdisplay(emailCheck.err_display);
    } else if (emailCheck.validition === true) {
      const mms_city_id = userId();
      let data = {
        mms_city_id: mms_city_id,
        new_email: emailAddress,
      };
      setErrdisplay("");
      VerificationHandlerApi(data);
    }
  };

  const VerificationHandlerApi = async (EmailCredentials) => {
    try {
      const Response = await newEmailApi(EmailCredentials, () => {
        navigate("/");
      });
      if (Response.status === 200) {
        toast.dismiss();
        toast.clearWaitingQueue();
        toast.success(Response.message, {
          position: "top-center",
          width: "500px",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        navigate("/otp/new-email");
        dispatch(getForgotPswdCounter(Response.timer));
      } else {
        toast.error(Response.message ?? "Something went wrong.", {
          position: "top-center",
          width: "auto",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    } catch (error) {
      toast.error("Something went wrong.", {
        position: "top-center",
        width: "auto",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">New Email Address</p>
          <Row>
            <Col md="4"></Col>
            <Col md="4">
              <div className="text-center mt-3">
                <Image className="w-100px" src={email}></Image>
                <p className="mt-4 redem-confirm">New E-mail</p>
                <Form
                  className="formmain mt-4 signin-row edit-mainform"
                  onSubmit={VerificationHandler}
                >
                  <Form.Group
                    className="mb-1 text-left"
                    controlId="formBasicEmail"
                  >
                    <Form.Label className="form-label-custom">
                      Enter new E-Mail
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter e-mail"
                      maxLength={70}
                      className="custom-formcontrol edit-form"
                      onChange={handleEmailChange}
                    />
                  </Form.Group>
                  <div className="error-div">
                    <ErrorLabel ErrorDisplay={errdisplay} />
                  </div>
                  <div className="d-flex vou-btns just-center mt-1">
                    <Button
                      variant="primary"
                      type="submit"
                      className="green-btn"
                    >
                      Send verification code
                    </Button>
                  </div>
                </Form>
              </div>
            </Col>
            <Col md="4"></Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default EditEmailAddress;
